import { j as H } from "./Spinner-yxPaS-Vf.js";
import { useRef as Q, useState as Y, useCallback as O, useLayoutEffect as tt } from "react";
import { css as R, styled as C } from "styled-components";
import { i as w } from "./isType-dZyoyzn5.js";
import { a as U, b as et } from "./backgroundSvg-O3FYVvtM.js";
import { A as rt } from "./TileSkeleton-QAoxs-Ce.js";
import { z as nt } from "./index-tc-On6zr.js";
import { j as G, a as z, B as it, m as ot } from "./style-ImpGK6sv.js";
import { b as st, c as I, a as at } from "./_commonjsHelpers-OnjxAlhP.js";
var K = { exports: {} };
function ct(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var A = { exports: {} };
const ht = {}, ft = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ht
}, Symbol.toStringTag, { value: "Module" })), ut = /* @__PURE__ */ st(ft);
var q;
function dt() {
  return q || (q = 1, function(e, a) {
    (function(n, s) {
      e.exports = s();
    })(I, function() {
      var n = n || function(s, l) {
        var h;
        if (typeof window < "u" && window.crypto && (h = window.crypto), typeof self < "u" && self.crypto && (h = self.crypto), typeof globalThis < "u" && globalThis.crypto && (h = globalThis.crypto), !h && typeof window < "u" && window.msCrypto && (h = window.msCrypto), !h && typeof I < "u" && I.crypto && (h = I.crypto), !h && typeof ct == "function")
          try {
            h = ut;
          } catch {
          }
        var d = function() {
          if (h) {
            if (typeof h.getRandomValues == "function")
              try {
                return h.getRandomValues(new Uint32Array(1))[0];
              } catch {
              }
            if (typeof h.randomBytes == "function")
              try {
                return h.randomBytes(4).readInt32LE();
              } catch {
              }
          }
          throw new Error("Native crypto module could not be used to get secure random number.");
        }, b = Object.create || /* @__PURE__ */ function() {
          function t() {
          }
          return function(r) {
            var o;
            return t.prototype = r, o = new t(), t.prototype = null, o;
          };
        }(), m = {}, _ = m.lib = {}, g = _.Base = /* @__PURE__ */ function() {
          return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function(t) {
              var r = b(this);
              return t && r.mixIn(t), (!r.hasOwnProperty("init") || this.init === r.init) && (r.init = function() {
                r.$super.init.apply(this, arguments);
              }), r.init.prototype = r, r.$super = this, r;
            },
            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function() {
              var t = this.extend();
              return t.init.apply(t, arguments), t;
            },
            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function() {
            },
            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function(t) {
              for (var r in t)
                t.hasOwnProperty(r) && (this[r] = t[r]);
              t.hasOwnProperty("toString") && (this.toString = t.toString);
            },
            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function() {
              return this.init.prototype.extend(this);
            }
          };
        }(), p = _.WordArray = g.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of 32-bit words.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.create();
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
           */
          init: function(t, r) {
            t = this.words = t || [], r != l ? this.sigBytes = r : this.sigBytes = t.length * 4;
          },
          /**
           * Converts this word array to a string.
           *
           * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
           *
           * @return {string} The stringified word array.
           *
           * @example
           *
           *     var string = wordArray + '';
           *     var string = wordArray.toString();
           *     var string = wordArray.toString(CryptoJS.enc.Utf8);
           */
          toString: function(t) {
            return (t || y).stringify(this);
          },
          /**
           * Concatenates a word array to this word array.
           *
           * @param {WordArray} wordArray The word array to append.
           *
           * @return {WordArray} This word array.
           *
           * @example
           *
           *     wordArray1.concat(wordArray2);
           */
          concat: function(t) {
            var r = this.words, o = t.words, f = this.sigBytes, v = t.sigBytes;
            if (this.clamp(), f % 4)
              for (var x = 0; x < v; x++) {
                var P = o[x >>> 2] >>> 24 - x % 4 * 8 & 255;
                r[f + x >>> 2] |= P << 24 - (f + x) % 4 * 8;
              }
            else
              for (var B = 0; B < v; B += 4)
                r[f + B >>> 2] = o[B >>> 2];
            return this.sigBytes += v, this;
          },
          /**
           * Removes insignificant bits.
           *
           * @example
           *
           *     wordArray.clamp();
           */
          clamp: function() {
            var t = this.words, r = this.sigBytes;
            t[r >>> 2] &= 4294967295 << 32 - r % 4 * 8, t.length = s.ceil(r / 4);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {WordArray} The clone.
           *
           * @example
           *
           *     var clone = wordArray.clone();
           */
          clone: function() {
            var t = g.clone.call(this);
            return t.words = this.words.slice(0), t;
          },
          /**
           * Creates a word array filled with random bytes.
           *
           * @param {number} nBytes The number of random bytes to generate.
           *
           * @return {WordArray} The random word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.random(16);
           */
          random: function(t) {
            for (var r = [], o = 0; o < t; o += 4)
              r.push(d());
            return new p.init(r, t);
          }
        }), i = m.enc = {}, y = i.Hex = {
          /**
           * Converts a word array to a hex string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The hex string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
           */
          stringify: function(t) {
            for (var r = t.words, o = t.sigBytes, f = [], v = 0; v < o; v++) {
              var x = r[v >>> 2] >>> 24 - v % 4 * 8 & 255;
              f.push((x >>> 4).toString(16)), f.push((x & 15).toString(16));
            }
            return f.join("");
          },
          /**
           * Converts a hex string to a word array.
           *
           * @param {string} hexStr The hex string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
           */
          parse: function(t) {
            for (var r = t.length, o = [], f = 0; f < r; f += 2)
              o[f >>> 3] |= parseInt(t.substr(f, 2), 16) << 24 - f % 8 * 4;
            return new p.init(o, r / 2);
          }
        }, c = i.Latin1 = {
          /**
           * Converts a word array to a Latin1 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Latin1 string.
           *
           * @static
           *
           * @example
           *
           *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
           */
          stringify: function(t) {
            for (var r = t.words, o = t.sigBytes, f = [], v = 0; v < o; v++) {
              var x = r[v >>> 2] >>> 24 - v % 4 * 8 & 255;
              f.push(String.fromCharCode(x));
            }
            return f.join("");
          },
          /**
           * Converts a Latin1 string to a word array.
           *
           * @param {string} latin1Str The Latin1 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
           */
          parse: function(t) {
            for (var r = t.length, o = [], f = 0; f < r; f++)
              o[f >>> 2] |= (t.charCodeAt(f) & 255) << 24 - f % 4 * 8;
            return new p.init(o, r);
          }
        }, u = i.Utf8 = {
          /**
           * Converts a word array to a UTF-8 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-8 string.
           *
           * @static
           *
           * @example
           *
           *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
           */
          stringify: function(t) {
            try {
              return decodeURIComponent(escape(c.stringify(t)));
            } catch {
              throw new Error("Malformed UTF-8 data");
            }
          },
          /**
           * Converts a UTF-8 string to a word array.
           *
           * @param {string} utf8Str The UTF-8 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
           */
          parse: function(t) {
            return c.parse(unescape(encodeURIComponent(t)));
          }
        }, S = _.BufferedBlockAlgorithm = g.extend({
          /**
           * Resets this block algorithm's data buffer to its initial state.
           *
           * @example
           *
           *     bufferedBlockAlgorithm.reset();
           */
          reset: function() {
            this._data = new p.init(), this._nDataBytes = 0;
          },
          /**
           * Adds new data to this block algorithm's buffer.
           *
           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
           *
           * @example
           *
           *     bufferedBlockAlgorithm._append('data');
           *     bufferedBlockAlgorithm._append(wordArray);
           */
          _append: function(t) {
            typeof t == "string" && (t = u.parse(t)), this._data.concat(t), this._nDataBytes += t.sigBytes;
          },
          /**
           * Processes available data blocks.
           *
           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
           *
           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
           *
           * @return {WordArray} The processed data.
           *
           * @example
           *
           *     var processedData = bufferedBlockAlgorithm._process();
           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
           */
          _process: function(t) {
            var r, o = this._data, f = o.words, v = o.sigBytes, x = this.blockSize, P = x * 4, B = v / P;
            t ? B = s.ceil(B) : B = s.max((B | 0) - this._minBufferSize, 0);
            var j = B * x, M = s.min(j * 4, v);
            if (j) {
              for (var k = 0; k < j; k += x)
                this._doProcessBlock(f, k);
              r = f.splice(0, j), o.sigBytes -= M;
            }
            return new p.init(r, M);
          },
          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = bufferedBlockAlgorithm.clone();
           */
          clone: function() {
            var t = g.clone.call(this);
            return t._data = this._data.clone(), t;
          },
          _minBufferSize: 0
        });
        _.Hasher = S.extend({
          /**
           * Configuration options.
           */
          cfg: g.extend(),
          /**
           * Initializes a newly created hasher.
           *
           * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
           *
           * @example
           *
           *     var hasher = CryptoJS.algo.SHA256.create();
           */
          init: function(t) {
            this.cfg = this.cfg.extend(t), this.reset();
          },
          /**
           * Resets this hasher to its initial state.
           *
           * @example
           *
           *     hasher.reset();
           */
          reset: function() {
            S.reset.call(this), this._doReset();
          },
          /**
           * Updates this hasher with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {Hasher} This hasher.
           *
           * @example
           *
           *     hasher.update('message');
           *     hasher.update(wordArray);
           */
          update: function(t) {
            return this._append(t), this._process(), this;
          },
          /**
           * Finalizes the hash computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The hash.
           *
           * @example
           *
           *     var hash = hasher.finalize();
           *     var hash = hasher.finalize('message');
           *     var hash = hasher.finalize(wordArray);
           */
          finalize: function(t) {
            t && this._append(t);
            var r = this._doFinalize();
            return r;
          },
          blockSize: 16,
          /**
           * Creates a shortcut function to a hasher's object interface.
           *
           * @param {Hasher} hasher The hasher to create a helper for.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
           */
          _createHelper: function(t) {
            return function(r, o) {
              return new t.init(o).finalize(r);
            };
          },
          /**
           * Creates a shortcut function to the HMAC's object interface.
           *
           * @param {Hasher} hasher The hasher to use in this HMAC helper.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
           */
          _createHmacHelper: function(t) {
            return function(r, o) {
              return new $.HMAC.init(t, o).finalize(r);
            };
          }
        });
        var $ = m.algo = {};
        return m;
      }(Math);
      return n;
    });
  }(A)), A.exports;
}
(function(e, a) {
  (function(n, s) {
    e.exports = s(dt());
  })(I, function(n) {
    return function() {
      var s = n, l = s.lib, h = l.WordArray, d = l.Hasher, b = s.algo, m = [], _ = b.SHA1 = d.extend({
        _doReset: function() {
          this._hash = new h.init([
            1732584193,
            4023233417,
            2562383102,
            271733878,
            3285377520
          ]);
        },
        _doProcessBlock: function(g, p) {
          for (var i = this._hash.words, y = i[0], c = i[1], u = i[2], S = i[3], $ = i[4], t = 0; t < 80; t++) {
            if (t < 16)
              m[t] = g[p + t] | 0;
            else {
              var r = m[t - 3] ^ m[t - 8] ^ m[t - 14] ^ m[t - 16];
              m[t] = r << 1 | r >>> 31;
            }
            var o = (y << 5 | y >>> 27) + $ + m[t];
            t < 20 ? o += (c & u | ~c & S) + 1518500249 : t < 40 ? o += (c ^ u ^ S) + 1859775393 : t < 60 ? o += (c & u | c & S | u & S) - 1894007588 : o += (c ^ u ^ S) - 899497514, $ = S, S = u, u = c << 30 | c >>> 2, c = y, y = o;
          }
          i[0] = i[0] + y | 0, i[1] = i[1] + c | 0, i[2] = i[2] + u | 0, i[3] = i[3] + S | 0, i[4] = i[4] + $ | 0;
        },
        _doFinalize: function() {
          var g = this._data, p = g.words, i = this._nDataBytes * 8, y = g.sigBytes * 8;
          return p[y >>> 5] |= 128 << 24 - y % 32, p[(y + 64 >>> 9 << 4) + 14] = Math.floor(i / 4294967296), p[(y + 64 >>> 9 << 4) + 15] = i, g.sigBytes = p.length * 4, this._process(), this._hash;
        },
        clone: function() {
          var g = d.clone.call(this);
          return g._hash = this._hash.clone(), g;
        }
      });
      s.SHA1 = d._createHelper(_), s.HmacSHA1 = d._createHmacHelper(_);
    }(), n.SHA1;
  });
})(K);
var lt = K.exports;
const gt = /* @__PURE__ */ at(lt), E = (e) => {
  if (w(e, "width"))
    return e.width;
  if (w(e, "aspectRatio") && w(e, "height")) {
    const { height: a, aspectRatio: n } = e;
    return a * n;
  }
}, L = (e) => {
  if (w(e, "maxWidth"))
    return e.maxWidth;
  if (w(e, "aspectRatio") && w(e, "maxHeight")) {
    const { maxHeight: a, aspectRatio: n } = e;
    return a * n;
  }
}, X = (e) => {
  if (w(e, "height"))
    return e.height;
  if (w(e, "aspectRatio") && w(e, "width")) {
    const { width: a, aspectRatio: n } = e;
    return a / n;
  }
}, Z = (e) => {
  if (w(e, "maxHeight"))
    return e.maxHeight;
  if (w(e, "aspectRatio") && w(e, "maxWidth")) {
    const { maxWidth: a, aspectRatio: n } = e;
    return a / n;
  }
}, T = (e) => {
  if (e != null && e.toString)
    return `${e}px`;
}, pt = 3200, W = (e, a) => Math.min(Math.round(e * a), pt), mt = 3, yt = (e) => {
  const a = new URL(e), n = new URL(a.pathname, e);
  return a.searchParams.has("hash") && n.searchParams.append("hash", a.searchParams.get("hash")), n.toString();
}, vt = (e, a) => {
  const n = new URL(e);
  return Object.entries(a).forEach(([s, l]) => {
    l != null && l.toString() && (n.searchParams.delete(s), n.searchParams.append(s, l.toString()));
  }), n.searchParams.has("hash") && (n.searchParams.delete("hash"), n.searchParams.append("hash", xt(n.toString()))), n.toString();
}, xt = (e) => {
  const a = new URL(e), n = `${a.pathname.substring(1)}?${new URLSearchParams({
    ...Object.fromEntries(a.searchParams.entries())
  }).toString()}`;
  return gt(n.toLowerCase()).toString();
}, J = {
  height: "h",
  width: "w",
  maxWidth: "maxWidth",
  maxHeight: "maxHeight"
}, wt = {
  ...J,
  maxWidth: "mw",
  maxHeight: "mh"
}, D = (e) => {
  if (!U(e.src))
    return;
  const a = e.src, n = E(e), s = L(e), l = n || s;
  if (!l)
    return;
  const h = yt(a), d = X(e), b = Z(e) || s && 5e3, _ = new URL(h).searchParams.has("hash") ? wt : J;
  return Array.from(Array(mt)).map((g, p) => {
    const i = p + 1, y = {
      w: n && W(n, i),
      h: d && W(d, i),
      [_.maxWidth]: s && W(s, i),
      [_.maxHeight]: b && W(b, i)
    };
    return `${vt(h, y)} ${W(l, i)}w`;
  }).join(", ");
}, F = R`
  ${G("opacity")};
  content: '';
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
`, St = C.img`
  ${G("opacity")};

  display: block;
  opacity: ${({ $imageStatus: e }) => e === "ready" ? 1 : 0};
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  object-fit: ${({ $objectFit: e }) => e};
  object-position: ${({ $objectPosition: e }) => e};
`, _t = C.picture`
  display: block;
  grid-row-start: 1;
  grid-column-start: 1;
  ${({ $images: e }) => Object.entries(e).map(([a, n]) => {
  if (w(n, "aspectRatio")) {
    const { aspectRatio: s } = n;
    return z(
      a,
      R`
            aspect-ratio: ${s || "inherit"};
          `
    );
  } else {
    const s = X(n), l = Z(n);
    if (s)
      return z(
        a,
        R`
              height: ${s}px;
            `
      );
    if (l)
      return z(
        a,
        R`
              max-height: ${l}px;
            `
      );
  }
})}

  &::before {
    ${F};
    opacity: ${({ $imageStatus: e }) => e === "loading" ? 1 : 0};
    ${({ $imageStatus: e }) => {
  if (e === "loading")
    return R`
          ${rt};
          background-size: cover;
        `;
}}
  }

  &::after {
    ${F};
    opacity: ${({ $imageStatus: e }) => e === "error" ? 1 : 0};
    ${({ $imageStatus: e }) => {
  if (e === "error")
    return R`
          ${et("fallbackImage")};
          background-size: contain;
        `;
}}
  }
`, N = C.div`
  display: grid;
  position: relative;
  grid-template-rows: 100%;
  grid-template-columns: 1fr;
`, bt = C.div`
  grid-row-start: 1;
  grid-column-start: 1;
  z-index: ${nt.base};
  align-self: center;
`, V = ({ images: e, lazyLoad: a = !0, objectFit: n, objectPosition: s, ...l }) => {
  const h = Q(null), d = e.xs, b = U(d == null ? void 0 : d.src), [m, _] = Y(b ? "loading" : "error"), g = (c) => {
    var u;
    (u = h.current) != null && u.complete && _(c);
  }, p = O(() => g("error"), []), i = O(() => g("ready"), []);
  tt(() => {
    const c = h.current;
    c != null && c.complete && (c.naturalWidth === 0 || c.naturalHeight === 0 ? p() : i());
  }, [p, i]);
  const y = (c) => E(c) ?? L(c);
  return /* @__PURE__ */ H.jsxs(_t, { $images: e, $imageStatus: m, children: [
    Object.entries(e).filter(([c, u]) => U(u == null ? void 0 : u.src) && c !== it.xs).map(([c, u]) => {
      const S = E(u) ?? L(u);
      return /* @__PURE__ */ H.jsx(
        "source",
        {
          media: ot(c),
          srcSet: D(u),
          sizes: T(S)
        },
        c
      );
    }).reverse(),
    /* @__PURE__ */ H.jsx(
      St,
      {
        ...l,
        $objectFit: n,
        $objectPosition: s,
        ref: h,
        srcSet: D(d),
        sizes: T(y(d)),
        src: d == null ? void 0 : d.src,
        onLoad: i,
        onError: p,
        $imageStatus: m,
        loading: a ? "lazy" : void 0
      }
    )
  ] });
}, kt = (e) => {
  if (w(e, "isBackgroundImage", !0)) {
    const { alt: s = "", isBackgroundImage: l, children: h, className: d, ...b } = e;
    return /* @__PURE__ */ H.jsxs(N, { className: d, children: [
      /* @__PURE__ */ H.jsx(V, { ...b, alt: s }),
      h && /* @__PURE__ */ H.jsx(bt, { children: h })
    ] });
  }
  const { className: a, ...n } = e;
  return /* @__PURE__ */ H.jsx(N, { className: a, children: /* @__PURE__ */ H.jsx(V, { ...n }) });
};
export {
  kt as I
};
